export enum ChatSettingAction {
  INIT_CHATBOT_SETTING = "chatsetting/INIT_CHATBOT_SETTING",

  CHANGE_MAIN_COLOR = "chatsetting/CHANGE_MAIN_COLOR",
  CHANGE_SUB_COLOR = "chatsetting/CHANGE_SUB_COLOR",
  CHANGE_TITLE = "chatsetting/CHANGE_TITLE",
  CHANGE_MAIN_TITLE = "chatsetting/CHANGE_MAIN_TITLE",
  CHANGE_OPEN_TEXT = "chatsetting/CHANGE_OPEN_TEXT",
  CHANGE_GUIDE_TITLEA = "chatsetting/CHANGE_GUIDE_TITLEA",
  CHANGE_GUIDE_TITLEB = "chatsetting/CHANGE_GUIDE_TITLEB",
  CHANGE_GUIDE_TITLEC = "chatsetting/CHANGE_GUIDE_TITLEC",
  CHANGE_GUIDE_MESSAGEA = "chatsetting/CHANGE_GUIDE_MESSAGEA",
  CHANGE_GUIDE_MESSAGEC = "chatsetting/CHANGE_GUIDE_MESSAGEC",
  CHANGE_LAUNCHER_IMAGE = "chatsetting/CHANGE_LAUNCHER_IMAGE",
  CHANGE_TITLE_IMAGE = "chatsetting/CHANGE_TITLE_IMAGE",
  CHANGE_ICON_IMAGE = "chatsetting/CHANGE_ICON_IMAGE",
  CHANGE_CHAT_ICON_SIZE = "chatsetting/CHANGE_CHAT_ICON_SIZE",
  CHANGE_CHAT_LAUNCHER_STYLE = "chatsetting/CHANGE_CHAT_LAUNCHER_STYLE",
  CHANGE_END_MESSAGES = 'chatsetting/END_MESSAGES',
  CHANGE_CHAT_IMAGES = 'chatsetting/CHANGE_CHAT_IMAGES',

  CHANGE_IS_SYNC = "chatsetting/CHANGE_IS_SYNC",

  POST_CHATSETTING_REQUEST = "chatsetting/POST_CHATSETTING_REQUEST",
  POST_CHATSETTING_SUCCESS = "chatsetting/POST_CHATSETTING_SUCCESS",
  POST_CHATSETTING_FAILURE = "chatsetting/POST_CHATSETTING_FAILURE"
}

export enum ChatIconSize {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small"
}

export enum ChatLauncherStyleType {
  StyleA = "A",
  StyleB = "B",
  StyleC = "C"
}

export interface IChatImage {
  src: string;
  file: any;
  size: string;
  isDelete: boolean;
  uploaded: boolean;
}

interface InitChatbot {
  type: ChatSettingAction.INIT_CHATBOT_SETTING;
  payload: {
    chatSettingData: any;
  };
}

export interface ChangeMainColor {
  type: ChatSettingAction.CHANGE_MAIN_COLOR;
  payload: {
    mainColor: string;
  };
}

export interface ChangeSubColor {
  type: ChatSettingAction.CHANGE_SUB_COLOR;
  payload: {
    subColor: string;
  };
}

export interface ChangeTitle {
  type: ChatSettingAction.CHANGE_TITLE;
  payload: {
    title: string;
  };
}
export interface ChangeMainTitle {
  type: ChatSettingAction.CHANGE_MAIN_TITLE;
  payload: {
    title: string;
  };
}

export interface ChangeEndMessages {
  type: ChatSettingAction.CHANGE_END_MESSAGES;
  payload: {
    endMessages: string[];
  };
}

export interface ChangeOpenText {
  type: ChatSettingAction.CHANGE_OPEN_TEXT;
  payload: {
    openText: string;
  };
}

export interface ChangeGuideTitleA {
  type: ChatSettingAction.CHANGE_GUIDE_TITLEA;
  payload: {
    guideTitleA: string;
  };
}
export interface ChangeGuideTitleB {
  type: ChatSettingAction.CHANGE_GUIDE_TITLEB;
  payload: {
    guideTitleB: string;
  };
}
export interface ChangeGuideTitleC {
  type: ChatSettingAction.CHANGE_GUIDE_TITLEC;
  payload: {
    guideTitleC: string;
  };
}

export interface ChangeGuideMessageA {
  type: ChatSettingAction.CHANGE_GUIDE_MESSAGEA;
  payload: {
    guideMessageA: string;
  };
}
export interface ChangeGuideMessageC {
  type: ChatSettingAction.CHANGE_GUIDE_MESSAGEC;
  payload: {
    guideMessageC: string;
  };
}

export interface ChangeTitleImage {
  type: ChatSettingAction.CHANGE_TITLE_IMAGE;
  payload: {
    imageUrl: string;
  };
}
export interface ChangeIconImage {
  type: ChatSettingAction.CHANGE_ICON_IMAGE;
  payload: {
    imageUrl: string;
  };
}
export interface ChangeLauncherImage {
  type: ChatSettingAction.CHANGE_LAUNCHER_IMAGE;
  payload: {
    imageUrl: string;
  };
}

export interface ChangeChatImages {
  type: ChatSettingAction.CHANGE_CHAT_IMAGES;
  payload: {
    chatImages: IChatImage[];
  };
}

export interface IChatSettingState {
  mainColor: string;
  subColor: string;
  title: string;
  endMessages: string[];
  loading: boolean;
  mainTitle: string;
  openText: string;
  guideTitleA: string;
  guideTitleB: string;
  guideTitleC: string;
  guideMessageA: string;
  guideMessageC: string;
  titleImage: string;
  iconImage: string;
  chatImages: any[],
  launcherImage: string;
  launcherStyleType: ChatLauncherStyleType;
  error: string;
  iconSize: ChatIconSize;
  isSync: boolean;
}

export interface IPostSettingData {
  mainColor: string;
  subColor: string;
  mainTitle: string;
  title: string;
  endMessages: string[];
  openText?: string;
  guideTitleA?: string;
  guideTitleB?: string;
  guideTitleC?: string;
  guideMessageA?: string;
  guideMessageC?: string;
  titleImage?: any;
  iconImage?: any;
  chatImages?: IChatImage[],
  chatImagesNum?: number;
  launcherImage?: any;
  launcherStyleType: ChatLauncherStyleType;
  iconSize: ChatIconSize;
}

export interface PostChatSetting {
  type: ChatSettingAction.POST_CHATSETTING_REQUEST;
}

export interface PostChatSettingSuccess {
  type: ChatSettingAction.POST_CHATSETTING_SUCCESS;
}

export interface PostChatSettingFailure {
  type: ChatSettingAction.POST_CHATSETTING_FAILURE;
  payload: {
    error: string;
  };
}

interface ChangeChatIconSize {
  type: ChatSettingAction.CHANGE_CHAT_ICON_SIZE;
  payload: {
    size: ChatIconSize;
  };
}
interface ChangeLauncherStyle {
  type: ChatSettingAction.CHANGE_CHAT_LAUNCHER_STYLE;
  payload: {
    style: ChatLauncherStyleType;
  };
}

interface ChangeIsSync {
  type: ChatSettingAction.CHANGE_IS_SYNC;
}

export type ChatSettingActionTypes =
  | InitChatbot
  | ChangeMainColor
  | ChangeSubColor
  | ChangeTitle
  | ChangeEndMessages
  | ChangeMainTitle
  | ChangeOpenText
  | ChangeGuideTitleA
  | ChangeGuideTitleB
  | ChangeGuideTitleC
  | ChangeGuideMessageA
  | ChangeGuideMessageC
  | ChangeTitleImage
  | ChangeIconImage
  | ChangeLauncherImage
  | ChangeChatImages
  | PostChatSetting
  | PostChatSettingSuccess
  | PostChatSettingFailure
  | ChangeChatIconSize
  | ChangeLauncherStyle
  | ChangeIsSync;
